import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { BottomBar, LeftArrowIconStyled } from './TrlModalBottomBar.styled';

export const TrlModalBottomBar = ({ text, handleClick }) => (
  <BottomBar>
    <LeftArrowIconStyled icon={faArrowLeft} onClick={handleClick} />
    <Box onClick={handleClick}>
      <FormattedMessage id={text} />
    </Box>
  </BottomBar>
);

TrlModalBottomBar.propTypes = {
  text: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
};
